<div class="df-section df-load-failure">
	<div class="df-section__body">
		<div class="df-load-failure__rule"></div>
		@if (variant() === 'signed-out') {
			<h2 class="df-load-failure__h">You're signed out</h2>
			<p class="df-load-failure__p">Sign in again to get back to your funds.</p>
			<button type="button" class="btn btn-primary df-load-failure__primary" (click)="onPrimary()">
				Sign in
			</button>
		} @else {
			<h2 class="df-load-failure__h">This didn't finish loading</h2>
			<p class="df-load-failure__p">
				The app stopped partway through starting up. Reloading the page usually fixes it.
			</p>
			<button type="button" class="btn btn-primary df-load-failure__primary" (click)="onPrimary()">
				Reload
			</button>
			<button type="button" class="btn btn-link df-load-failure__secondary" (click)="onSignInAgain()">
				Sign in again
			</button>
			<p class="df-load-failure__hint">If it happens again, close the tab and open it fresh.</p>
		}
	</div>
</div>
